module.exports = __webpack_public_path__ + "static/github-d4b0af44a29008e4fe60c5f7835cfaa0.png";